import { apiClient } from '../../../core/api/client';

export type ShareProviderRequest = {
  referredProviderId: string;
  clientIds: string[];
  personalNote?: string;
  profileViewEngagementId?: string;
};

export type ProviderReferralResponse = {
  success: boolean;
  referralId: string;
  clientsSharedWith: number;
  message: string;
};

export type ReferralListItem = {
  id: string;
  referredProviderId: string;
  clientIds: string[];
  personalNote?: string;
  createdAt: string;
};

/**
 * Share a provider with selected clients
 * Feature 001: SP Client Management - Provider Referrals
 *
 * @param providerId - The referring service provider's user ID
 * @param data - Referred provider ID and array of client IDs
 * @returns Referral creation response with counts
 * @throws Error if request fails
 */
export async function shareProviderWithClients(
  providerId: string,
  data: ShareProviderRequest,
): Promise<ProviderReferralResponse> {
  const response = await apiClient.post<ProviderReferralResponse>(
    `/service-providers/${providerId}/referrals`,
    data,
  );

  return response.data;
}

/**
 * Get existing referrals for a specific referred provider
 * Used to show which clients have already been referred
 *
 * @param providerId - The referring service provider's user ID
 * @param referredProviderId - The referred provider's user ID
 * @returns Array of existing referrals
 * @throws Error if request fails
 */
export async function fetchProviderReferrals(
  providerId: string,
  referredProviderId: string,
): Promise<ReferralListItem[]> {
  const response = await apiClient.get<ReferralListItem[]>(
    `/service-providers/${providerId}/referrals?referredProviderId=${referredProviderId}`,
  );

  return response.data;
}
